function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "thumbs-up-black"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 1",
  cx: 60,
  cy: 60,
  r: 60,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "thmbs up",
  d: "M47.9999 83.9997H40.8C39.5269 83.9997 38.306 83.494 37.4059 82.5938C36.5057 81.6936 36 80.4728 36 79.1997V62.3998C36 61.1268 36.5057 59.9059 37.4059 59.0057C38.306 58.1056 39.5269 57.5999 40.8 57.5999H47.9999M64.7998 52.7999V43.2C64.7998 41.2904 64.0413 39.4591 62.691 38.1088C61.3407 36.7586 59.5094 36 57.5999 36L47.9999 57.5999V83.9997H75.0718C76.2293 84.0128 77.3526 83.6071 78.2347 82.8573C79.1168 82.1076 79.6981 81.0643 79.8717 79.9197L83.1837 58.3199C83.2881 57.6319 83.2417 56.9295 83.0477 56.2613C82.8537 55.593 82.5167 54.975 82.0602 54.4499C81.6036 53.9248 81.0383 53.5053 80.4035 53.2204C79.7687 52.9355 79.0795 52.792 78.3837 52.7999H64.7998Z",
  stroke: "#2B1C1C",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgThumbsUpBlack = function SvgThumbsUpBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUpBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-up-black.6215ea0e.svg";
export { ForwardRef as ReactComponent };